export const lightMapStyle = "mapbox://styles/mpilarczykstarcount/clzjoxepg004a01qx6ytt26kd"
export const darkMapStyle = "mapbox://styles/mpilarczykstarcount/clkgquj99007501qpdl0ebfr5"
